import { NO_SUB_CATEGORIES_POSTFIX } from '@/constants/various';
import { ICategory } from '@/models/categories.model';

export const getSubCategoriesData = (noChildrenText: string, id: string, subCategories?: ICategory[]) =>
  subCategories?.length ? subCategories : [{ id: `${id}${NO_SUB_CATEGORIES_POSTFIX}`, name: noChildrenText }];

// recursively search in categoriesList for category by targetCategoryId at all levels to update its subcategories list with newSubCategories
export const updateCategoryChildren = (
  categoriesList: ICategory[],
  targetCategoryId: string,
  newSubCategories: ICategory[] | undefined,
  noChildrenText: string,
): ICategory[] => {
  return categoriesList.map((category: ICategory) => {
    if (category.id === targetCategoryId) {
      return {
        ...category,
        sub_categories: getSubCategoriesData(noChildrenText, targetCategoryId, newSubCategories),
      };
    }
    if (category.sub_categories && category.sub_categories.length > 0) {
      return {
        ...category,
        sub_categories: updateCategoryChildren(
          category.sub_categories,
          targetCategoryId,
          newSubCategories,
          noChildrenText,
        ),
      };
    }
    return category;
  });
};
